{
  "blankError": "Описание проблемы не может быть пустым. Пожалуйста, опишите проблему.",
  "error": "Что-то пошло не так при обработке вашего запроса. Пожалуйста, попробуйте позже.",
  "error_blank": "Описание проблемы не может быть пустым. Пожалуйста, опишите проблему.",
  "placeholder": "Оставьте здесь комментарий и нажмите «отправить»",
  "title": "Расскажите, что вам не понравилось в ответе наставника?",
  "subtitle": "Без этого мы не сможем зачесть вашу оценку.\nНаставник не узнает о вашем комментарии",
  "send": "Отправить"
}
